module.exports = __webpack_public_path__ + "static/media/logo-house.8b3668bb.png";